/**
 * Creates an array of available slugs from Sanity translation metadata.
 *
 * @param {Object} metadata - The Sanity translation metadata object.
 * @param {Object} pageContext - The current page context.
 * @param {string} [prefix=''] - Optional prefix for the slug.
 * @returns {Array<Object>|undefined} An array of objects containing language and slug information,
 *                                    or undefined if no translations are found.
 *
 * @example
 * const availableSlugs = createAvailableSlugsFromSanityTranslationMetadata(
 *   sanityTranslationMetadata,
 *   pageContext,
 *   '/blog'
 * );
 *
 * // Returns: [{ lang: 'en', slug: '/blog/example-post/' }, { lang: 'es', slug: '/blog/ejemplo-post/' }]
 */
const createAvailableSlugsFromSanityTranslationMetadata = (
  metadata,
  pageContext,
  prefix = "",
) => {
  const translationMetaDataForThisDocument = metadata.nodes.find(node => {
    return (
      node.translations.length > 0 &&
      node.translations.find(
        translation => translation.value?._id === pageContext.id,
      )
    )
  })

  const availableSlugs = translationMetaDataForThisDocument?.translations
    ?.filter(
      translation =>
        translation.value?.language && translation.value?.slug?.current,
    )
    .map(translation => ({
      lang: translation.value.language,
      slug: `${prefix}/${translation.value.slug.current}/`,
    }))

  return availableSlugs?.length ? availableSlugs : undefined
}

export default createAvailableSlugsFromSanityTranslationMetadata
